import { AvatarSize } from '$common/avatar/avatar-base/types'

export const ROOM_APP_BAR_HEIGHT = 57
export const ROOM_APP_BAR_AVATAR_SIZE: AvatarSize = AvatarSize.SM
